/*
 * Scenario: remote-change-during-review
 *
 * Drei Rewrites, danach simuliert das Scenario eine Remote-Aenderung am
 * mittleren Paragraphen (via state.transport.triggerRemoteChange). Der
 * ReviewController muss den betroffenen Vorschlag dropen
 * (status='dropped'), die Console eine System-Notiz loggen, und die zwei
 * verbliebenen Vorschlaege bleiben pending.
 *
 * Sidechannel: MockAgentTransport.triggerRemoteChange() → onRemoteChange-
 * Callback (in main.js auf reviewController.onRemoteChange verdrahtet).
 */

import { emit, wait } from './_helpers.js'

export const name = 'remote-change-during-review'
export const description = 'Three rewrites; the middle one is dropped by a simulated remote change.'

export async function run(state) {
    await emit(state, 'session', { sessionId: 'mock-remote-change' }, 0)
    await emit(state, 'thinking', { text: 'Three small tweaks. (Watch what happens to the middle one.)' }, 250)
    await emit(state, 'thinkingDone', {}, 200)

    const paras = state.context?.cursorContext?.textParagraphs || []
    if (paras.length < 3) {
        await emit(state, 'delta', { text: 'Need at least three paragraphs for this demo.' }, 100)
        await emit(state, 'done', { usage: {} }, 100)
        return
    }
    const targets = [paras[0], paras[1], paras[2]]
    const toolCallIds = []
    for (let i = 0; i < 3; i++) {
        const p = targets[i]
        const toolCallId = `tu_rcdr_${i}_${Date.now().toString(36)}`
        toolCallIds.push(toolCallId)
        await emit(state, 'proposeRewrite', {
            toolCallId,
            paragraphId: p.id,
            baseVersion: typeof p.version === 'number' ? p.version : undefined,
            originalText: p.text,
            newText: ['Polished version A.', 'Polished version B.', 'Polished version C.'][i],
            reason: 'Routine polish.'
        }, 200)
    }
    await emit(state, 'done', { usage: {} }, 200)

    // Nach 600 ms: simuliere eine Remote-Aenderung am mittleren Paragraphen.
    // ReviewController dropt den Vorschlag, meldet 'rejected' fuer den
    // Sidechannel-Hook und logged eine System-Notiz.
    setTimeout(() => {
        try {
            state.transport?.triggerRemoteChange?.([targets[1].id])
        } catch { /* still */ }
    }, 600 * (state.delayScale ?? 1))

    let applied = 0, rejected = 0
    try {
        // ReviewController meldet bei DROPPED den Sidechannel-Hook auch als
        // 'rejected' (siehe ReviewController._reportResult). Wir zaehlen also
        // nur applied/rejected — die Drop-Begruendung steht in der Console.
        const results = await Promise.all(toolCallIds.map(id => wait(state, id, 5 * 60 * 1000)))
        for (const info of results) {
            if (info.result === 'applied') applied++
            else rejected++
        }
        await emit(state, 'delta', {
            text: `Done. ${applied} applied, ${rejected} rejected (one was dropped by an external change).`
        }, 250)
        await emit(state, 'done', { usage: {} }, 100)
    } catch { /* abort */ }
}
